import { settingsPaths } from '../paths/paths.settings'

export const SETTINGS_SCREEN_HEADER_DESCRIPTORS = [
  { path: settingsPaths.categoriesThematic, title: 'Тематические категории' },
  // { path: settingsPaths.categoriesAge, title: 'Возрастные категории' },
]
